import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { AddSensor, fetchDeviceById, fetchTypes } from '../appActions';
import cross_logo from '../Assets/Icons/cross.png'
import callApi from '../util/callApi';
import Select from 'react-select'
import { height } from '@mui/system';
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    
    background: 'linear-gradient(135deg, rgba(0, 92, 255, 0.1), rgba(255, 255, 255, 0.05))',
    boxShadow: ' 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 0 30px rgba(0, 128, 255, 0.05)',
    borderRadius: '8px',
    border: 'none',
    color: 'white',
    height: '50px',
    width: '100%',
    gridArea: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    // Prevent keyboard on mobile
    touchAction: 'manipulation',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none'
    
  }),
  container: (provided) => ({
    ...provided,
    position: 'relative',
    width: '100%'
  }),
  valueContainer: (provided) => ({
    ...provided,
    color: 'white',
    padding: '0 8px'
  }),
  input: (provided) => ({
    ...provided,
    // Prevent keyboard popup on mobile
    caretColor: 'transparent',
    color: 'white',
    // Disable text input behavior
    pointerEvents: 'none',
    // Prevent autocomplete and autocorrect
    WebkitAppearance: 'none',
    WebkitTextFillColor: 'white',
    // Disable input on mobile
    WebkitUserSelect: 'none',
    userSelect: 'none',
    // Prevent keyboard
    readOnly: true,
    // Additional mobile-specific properties
    WebkitTouchCallout: 'none',
    WebkitTapHighlightColor: 'transparent',
    // Additional properties for better mobile prevention
    inputMode: 'none',
    autoComplete: 'off',
    autoCorrect: 'off',
    autoCapitalize: 'off',
    spellCheck: false,
    // Prevent focus and selection
    outline: 'none',
    // Disable text selection
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none'
  }),
  menu: (provided) => ({
    ...provided,
    background: 'black',
    borderRadius: '10px',
    border: '1px solid rgba( 255, 255, 255, 0.18 )',
    fontSize: '12px',
    color: 'white',
    // Fix menu positioning
    position: 'absolute',
    zIndex: 9999,
    width: '100%',
    // Remove height from here - it doesn't work properly
    overflowX: 'hidden'
  }),
  menuList: (provided) => ({
    ...provided,
    // Set the height here instead - this controls the scrollable area
    maxHeight: '300px',
    overflowY: 'auto',
    // Optional: Set a minimum height if needed
     minHeight: '200px',
    
    // Custom scrollbar styling (optional)
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255, 255, 255, 0.5)',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
    color: 'white',
    padding: '12px 10px',
    // Remove height from here - let it be auto
    margin: '4px 0',
    borderRadius: '6px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  }),
  
  placeholder: (provided) => ({
    ...provided,
    color: 'white',
  }),
};

function AddSensorForm({mode, setCloseModal, device_id, editObject, sensor_no}) {

  const { register, handleSubmit, setValue, getValues, formState: { errors }, control } = useForm({defaultValues: editObject ? editObject : {'save_data':true}});
  const [typeOptions, setTypeOptions] = useState([])
  const dispatch = useDispatch()
  const state = useSelector((state) => state);

  useEffect(() => {
    if(!state.types){
      dispatch(fetchTypes())
    }
  }, [])
  
  useEffect(() => {
    if (state?.types) {
      setTypeOptions(state.types.map(type => ({
        value: type._id,
        label: `${type.name} - ${type.code}`
      })))
    }
  }, [state.types])

  const [intervalOptions, setIntervalOptions] = useState([
    {label: '10 seconds', value: 10},
    {label: '30 seconds', value: 30},
    {label: '1 minute', value: 60},
    {label: '5 minutes', value: 300},
    {label: '10 minutes', value: 600},
    {label: '3 hours', value: 10800},
    {label: '6 hours', value: 21600},
    {label: '12 hours', value: 43200},
    {label: '24 hours', value: 86400},
    {label: '48 hours', value: 172800},
  ])

  const onSubmit = (data)=>{
    if(mode === 'edit'){
      data._id = editObject._id
      if(data.save_data){
        data.last_save_data = new Date()
      }else{
        data.last_save_data = null
      }
      callApi('edit_sensor','post',data).then(res=>{
        if(res.status === 'Success'){
          alert("Sensor updated succesfully!")
          dispatch(fetchDeviceById({_id:device_id}))
          setCloseModal(false)
        }else{
          alert("An error occured. Please try again!")
          dispatch(fetchDeviceById({_id:device_id}))
          setCloseModal(false)
        }
      })
    }else{
      if(data.save_data){
        data.last_save_data = new Date()
      }else{
        data.last_save_data = null
      }
      data.device_id = device_id
      data.sensor_no =  sensor_no
      dispatch(AddSensor(data)).then(obj=>{
        setCloseModal(false)
      })
    }
  }

  return (
    <div className='modal'>
      <form >
        <img onClick={()=>{setCloseModal(false)}} className='form-cross-but' src={cross_logo} alt="" />
        <label className='form-label' htmlFor="">
          Sensor Name
          <input type="text" {...register('name',{ required: true })}/>
        </label>
        <label htmlFor="" className='form-label'>
          Select Type
          <Select
            styles={customStyles}
            options={typeOptions}
            value={typeOptions.find(option => option.value === (getValues('type') || (editObject && editObject.type)))}
            onChange={option => setValue('type', option.value, { shouldValidate: true })}
            placeholder="Select"
            isSearchable={false}
            name="type"
          />
          {errors.type && <span style={{color: 'red', fontSize: '12px'}}>Type is required</span>}
        </label>
        <label htmlFor="" className='form-label'>
          Select Fetch Interval
          <Select
            styles={customStyles}
            options={intervalOptions.map(interval => ({ value: interval.value, label: interval.label }))}
            value={intervalOptions.map(interval => ({ value: interval.value, label: interval.label })).find(option => option.value === (getValues('fetch_interval') || (editObject && editObject.fetch_interval)))}
            onChange={option => setValue('fetch_interval', option.value, { shouldValidate: true })}
            placeholder="Select"
            isSearchable={false}
            name="fetch_interval"
          />
          {errors.fetch_interval && <span style={{color: 'red', fontSize: '12px'}}>Fetch interval is required</span>}
        </label>
        <label className='form-label form-label-checkbox' htmlFor="">
          Save Data?
          <input type="checkbox"  {...register('save_data')}/>
        </label>
        {/* <label className='form-label form-label-checkbox' htmlFor="">
          Hide in report?
          <input type="checkbox" {...register('hide_report')}/>
        </label> */}
        <div className="form-but-group">
          <button className='form-but-1' onClick={handleSubmit(onSubmit)} type="button">
          {
          mode === 'edit'?
            'Save'
          :
            'Add'
          }
          </button>
          </div>
      </form>
    </div>
  )
}

export default AddSensorForm